import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

//------------------------------------------------------------------------------
//               Отправить запрос на получение информации о посте
//------------------------------------------------------------------------------
export const pinPost = async (data, isPin) => {
  try{
    const url = `${backendUrl}/api/alpha/pin/`;
    const options = {
      method: isPin ? 'POST' : 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    };
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при закреплении поста: HTTP error! Status: ${ response.status }`);
    }
    return response;
  } catch(error){
    console.error('Программная ошибка закрепления поста:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx